var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayValue > 0)?_c('span',{staticClass:"text-success"},[_vm._v("+"+_vm._s(_vm.currency(_vm.displayValue)))]):(_vm.displayValue < 0)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.currency(_vm.displayValue)))]):_c('span',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.currency(_vm.displayValue)))])
}
var staticRenderFns = []

export { render, staticRenderFns }